export const money = (v, code = 'EUR') => `${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${code}`;
export const date = v => (v ? new Date(v).toISOString().slice(0, 10) : '');
export const statusColor = s => ({
  DRAFT: 'var(--gray-400)',
  SENT: 'var(--steel)',
  PARTIALLY_PAID: 'var(--warning)',
  PAID: 'var(--success)',
  OVERDUE: 'var(--danger)',
  CANCELLED: 'var(--gray-400)',
  VOIDED: 'var(--gray-600)',
}[s] || 'var(--gray-400)');
